<script setup lang="ts">
import { computed } from 'vue'
import { useFilterStore } from 'Store/filterStore'
import { formatDate } from 'Common/utils/formatDate'

interface PropTypes {
  aircraftData: Array<any>
  inspectionData: Array<any>
}

const props = defineProps<PropTypes>()
const filterStore = useFilterStore()

const isMultipleAircraft = computed<boolean>(() => props.aircraftData?.length > 1)

//Filtering by 0 inspection instances will return multiple inspection instances
//as will filtering by multiple inspection instances
//none should currently be possible via page navigation
//but catching to ensure no erreneous visual state and to setup for allowing multiple
const isMultipleInspectionInstances = computed<boolean>(
  () =>
    filterStore.filtersModel.inspectionInstance?.length > 1 || filterStore.filtersModel.inspectionInstance?.length === 0
)

const currentInspectionUuid = computed(() => filterStore.filtersModel.inspectionInstance?.[0])
const currentAircraftUuid = computed(() => filterStore.filtersModel.aircraft?.[0])

const currentInspectionInstance = computed(() =>
  props.inspectionData?.find((inspection) => inspection?.inspectionInstanceUuid === currentInspectionUuid.value)
)
const currentAircraft = computed(() =>
  props.aircraftData?.find((airCraft) => airCraft?.uuid === currentAircraftUuid.value)
)
const currentAircraftInspectionInstances = computed(() =>
  props.inspectionData?.filter((inspectionInstance) => inspectionInstance.aircraftUuid === currentAircraftUuid.value)
)
</script>

<template>
  <div class="h-full flex flex-col bg-slate-100 border border-gray-200 shadow-lg rounded-lg mb-2">
    
    <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 mb-6 border-b-2 ">
        <div>
            <template v-if="!isMultipleAircraft">
            <!-- Avatar and Title Section -->
            <div class="p-6 flex items-center shrink">
                <img :src="currentAircraft?.imageUrl" alt="avatar" class="w-20 h-20 rounded-full" />
                <div class="ml-4 flex flex-col items-start justify-center w-full">
                <h1 class="text-xl font-semibold">{{ currentAircraft?.tailNumber }}</h1>
                <p class="text-gray-500">{{ currentAircraft?.modelName }} | {{ currentAircraft?.owner }}</p>
                </div>
            </div>
            </template>
        </div>
         <div>
            <template v-if="!isMultipleInspectionInstances">
            <!-- Inspection Details Section -->
            <div class="p-6 shrink">
                <h3 class="text-lg font-bold text-gray-700 pb-4">Inspection Details</h3>
                <table class="w-full text-left text-gray-500">
                <tbody>
                    <tr>
                    <td class="py-1">Date:</td>
                    <td class="py-1">
                        {{ currentInspectionInstance?.startDate ? formatDate(currentInspectionInstance?.startDate) : '' }}
                    </td>
                    </tr>
                    <tr>
                    <td class="py-1">Inspection:</td>
                    <td class="py-1">{{ currentInspectionInstance?.type ? currentInspectionInstance.type : '' }}</td>
                    </tr>
                </tbody>
                </table>
            </div>
            </template>
         </div>
        
    </div>

    <div>
        <!-- Inspection Progress Section -->
        <div class="p-6  shrink">
        <h3 class="text-lg font-bold text-gray-700 mb-4">Inspection Progress</h3>
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-6 ">
        <div class="mb-2">
            <p class="text-gray-500 mb-1">Images Reviewed</p>
            <el-progress
            :percentage="
                Math.floor(
                (currentInspectionInstance?.imagesReviewedCount / currentInspectionInstance?.imagesCapturedCount) * 100
                )
            "
            color="#409EFF"
            show-text
            :text-inside="false"
            class="mb-4"
            />
        </div>

        <!-- Progress Bar 2 -->
        <div>
            <p class="text-gray-500 mb-1">Images Captured</p>
            <el-progress
            :percentage="
                Math.floor(
                (currentInspectionInstance?.uniqueImagesCapturedCount / currentInspectionInstance?.missionWaypointCount) *
                    100
                )
            "
            color="#67C23A"
            show-text
            :text-inside="false"
            />
        </div>
        </div>
        </div>
    </div>
    
  </div>
</template>
